import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledTableHeader = styled.div`
  ${setFontVariant('listSectionTitle', colorsPalettes.carbon[250])};
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 8px;
  width: 100%;
`;

export const StyledTableHeaderItem = styled.span<{ width?: string }>`
  width: ${({ width }) => width || '100%'};
  flex: ${({ width }) => (width ? 'none' : 'auto')};
  text-align: right;

  &:first-child {
    text-align: left;
  }
`;

export const StyledTableBody = styled.div<{ showPagination: boolean }>`
  width: 100%;
  border-bottom: ${({ showPagination }) => (showPagination ? `1px solid ${colorsPalettes.carbon[50]}` : 'none')};
`;

export const StyledTableItem = styled.div`
  min-height: 55px;
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
  padding: 11px 16px;
  gap: 8px;
  ${setFontVariant('report', colorsPalettes.carbon[400])};
  border-top: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledPaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  padding: 12px 24px 0 12px;
`;
